import React from 'react';
import { noop, isEmpty, get, map, castArray } from 'lodash';
import classnames from 'classnames';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { GLOBAL_LABELS, SIZES } from 'constants/common';
import { button as Button } from 'modules/button';
import { Icon } from 'modules/icon-bank';
import { widgetError as WidgetError } from 'ui/views/widgets/widgetError';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { errorOverlay as ErrorOverlay } from 'ui/views/widgets/errorOverlay';
 *
 * // render
 * <ErrorOverlay propName='propValue'/>
 */
export const errorOverlay = ( props ) => {

    // widget class name
    const widgetClassName = classnames( 'ui-error-overlay', props.className, {
        [ `ui-error-overlay--size-${ props.size }` ]: ! isEmpty( props.size ),
        [ `ui-error-overlay--template-${ props.templateType }` ]: ! isEmpty( props.templateType ),
    } );

    // check if user is to set dangerously
    const setDangerously = get( props, 'setDangerously', false );

    return (
        <div className={ widgetClassName }>

            {/* head */}
            <div className='ui-error-overlay__head'>
                {/* title */}
                <div className='ui-error-overlay__head__title'>
                    { getLabel( GLOBAL_LABELS.DISPLAY_TEXT_ERROR ) }
                </div>

                {/* close button */}
                <div className='ui-error-overlay__head__close' onClick={ () => props.closeOverlay() }>
                    <Icon name='close' width='14' height='14' fill='#ffffff' />
                </div>
            </div>

            {/* body */}
            {
                props.size === SIZES.SMALL ? (
                    <div className='ui-error-overlay__body-small'>

                        {/* icon */}
                        <div className='ui-error-overlay__body-small__icon'>
                            <Icon name='warningBlue'/>
                        </div>

                        {/* message and data */}
                        {
                            setDangerously ? (
                                <div className='ui-error-overlay__body-small__message' dangerouslySetInnerHTML={ { __html: props.message } } />
                            ) : (
                                ( () => {

                                    // fields template
                                    if( 'fields' === props.templateType ) {
                                        return (
                                            <div className='ui-error-overlay__body-small__fields'>

                                                {/* message */}
                                                <div className='ui-error-overlay__body-small__fields__message'>
                                                    { props.message }
                                                </div>

                                                {/* fields */}
                                                {
                                                    ! isEmpty( props.data.fields ) ? (
                                                        <div className='ui-error-overlay__body-small__fields__values'>
                                                            {
                                                                map( props.data.fields, field => {
                                                                    return (
                                                                        <div key={ field.name } className='ui-error-overlay__body-small__fields__values__item'>
                                                                            <div className='ui-error-overlay__body-small__fields__values__item__label'>
                                                                                { getLabel( field.title ) }
                                                                            </div>
                                                                            <div className='ui-error-overlay__body-small__fields__values__item__values'>
                                                                                {
                                                                                    map( castArray( get( props, `data.values.${ field.name }`, [] ) ), ( value, index ) => {
                                                                                        return (
                                                                                            <div key={ index } className='ui-error-overlay__body-small__fields__values__item__values__item'>
                                                                                                { value }
                                                                                            </div>
                                                                                        );
                                                                                    } )
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                } )
                                                            }
                                                        </div>
                                                    ) : null
                                                }
                                            </div>
                                        );
                                    }

                                    // default template
                                    return (
                                        <div className='ui-error-overlay__body-small__message'>
                                            { props.message }
                                        </div>
                                    );
                                } )()
                                
                            )
                        }
                    </div>
                ) : (
                    <div className='ui-error-overlay__body'>
                        <WidgetError />
                    </div>
                )
            }

            <div className='ui-error-overlay__actions'>
                <Button
                    className='ui-error-overlay__actions__close'
                    title={ {
                        refId: '',
                        value: props.size === SIZES.SMALL ? getLabel( GLOBAL_LABELS.DISPLAY_TEXT_OK ) : getLabel( GLOBAL_LABELS.DISPLAY_TEXT_CLOSE ),
                    } }
                    onClick={ () => props.closeOverlay() }
                    size='large'
                />
            </div>
        </div>
    );
};

// set display name
errorOverlay.displayName = 'errorOverlay';

// set default props
errorOverlay.defaultProps = {
    closeOverlay: noop,
    size: null,
    title: null,
    message: null,
    templateType: null, // values: null, 'default', 'fields'
    data: {}, // data for template
};

// prop types
errorOverlay.propTypes = {};
